import { useRef, useState } from "react";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
//internal imports
import { FtextField } from "../../../components/common/FtextField";
import "../../Customer/customer.css";
import { useDispatch } from "react-redux";
import Loader from "../../../components/common/Loader";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { billCollectInvoice } from "../../../features/apiCalls";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import useISPowner from "../../../hooks/useISPOwner";
import CustomerInvoicePrint from "../customerInvoicePrint/CustomerInvoicePrint";
import ReactToPrint from "react-to-print";
import { CashStack } from "react-bootstrap-icons";

export default function CustomerBillCollectInvoice({
  show,
  setShow,
  invoiceId,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const rechargePrint = useRef();

  //---> Get user & current user data form useISPOwner hooks
  const {
    role,
    ispOwnerId,
    ispOwnerData,
    bpSettings,
    userData,
    currentUser,
    permissions,
  } = useISPowner();

  // all customer invoice
  const allInvoice = useSelector((state) => state?.payment?.customerInvoice);

  const invoice = allInvoice.find((item) => item.id === invoiceId);

  const [isLoading, setLoading] = useState(false);
  const [medium, setMedium] = useState("cash");
  const [billAmount, setBillAmount] = useState();
  const [balanceDue, setBalanceDue] = useState();
  const [noteCheck, setNoteCheck] = useState(false);
  const [note, setNote] = useState("");

  const totalAmount = Number(billAmount) + Number(balanceDue);
  const maxDiscount = totalAmount;

  //Validation
  const BillValidatoin = Yup.object({
    amount: Yup.number()
      .min(invoice?.amount, t("billNotAcceptable"))
      .integer(t("decimalNumberNotAcceptable")),
    due: Yup.number()
      .min(invoice?.due, t("dueNotAcceptable"))
      .integer(t("decimalNumberNotAcceptable")),
    discount: Yup.number()
      .min(invoice?.discount, t("discountNotAcceptable"))
      .max(maxDiscount, t("discountNotAcceptable"))
      .integer(t("decimalNumberNotAcceptable")),
  });

  //form resetFunction
  const resetForm = () => {
    setBillAmount(invoice?.amount);
  };

  useEffect(() => {
    setBalanceDue(invoice?.due);
    setBillAmount(invoice?.amount);
    setNote(invoice?.note);
  }, [invoice]);

  const handleFormValue = (event) => {
    if (event.target.name === "amount") {
      setBillAmount(event.target.value);
    }
    if (event.target.name === "due") {
      setBalanceDue(event.target.value);
    }
  };

  // bill amount
  const invoiceSubmitHandler = (formValue) => {
    const sendingData = {
      amount: formValue.amount + formValue.due,
      discount: formValue.discount,
      name: userData.name,
      collectedBy: currentUser?.user.role,
      billType: "bill",
      customer: invoice?.customer?.id,
      ispOwner: ispOwnerId,
      user: currentUser?.user.id,
      collectorId: userData?.id,
      userType: invoice?.customer?.userType,
      medium,
      package: invoice?.customer?.pppoe.profile,
    };

    if (invoice?.note) sendingData.note = invoice?.note;

    if (invoice?.start && invoice?.end) {
      sendingData.start = invoice?.start;
      sendingData.end = invoice?.end;
    }
    if (invoice?.month) sendingData.month = invoice?.month;

    billCollectInvoice(
      dispatch,
      sendingData,
      setLoading,
      resetForm,
      invoiceId,
      setShow,
    );
  };

  return (
    <ComponentCustomModal
      show={show}
      setShow={setShow}
      centered={false}
      size={"md"}
      header={t("createInvoice")}
    >
      <div>
        <table className="table table-bordered" style={{ lineHeight: "12px" }}>
          <tbody>
            <tr>
              <td>{t("id")}</td>
              <td>
                <b>{invoice?.customer?.customerId}</b>
              </td>
              <td>{t("pppoe")}</td>
              <td>
                <b>{invoice?.customer?.pppoe.name}</b>
              </td>
            </tr>
            <tr>
              <td>{t("name")}</td>
              <td>
                <b>{invoice?.customer?.name}</b>
              </td>
              <td>{t("mobile")}</td>
              <td className="text-primary">
                <b>{invoice?.customer?.mobile}</b>
              </td>
            </tr>
            <tr>
              <td>{t("monthly")}</td>
              <td className="text-primary">
                <b>{invoice?.customer?.monthlyFee}</b>
              </td>
              <td>{t("balance")}</td>
              <td
                className={
                  invoice?.customer?.balance < 0
                    ? "text-danger"
                    : "text-success"
                }
              >
                <b>{invoice?.customer?.balance}</b>
              </td>
            </tr>
          </tbody>
        </table>

        <Formik
          initialValues={{
            billingType: "monthly",
            amount: invoice?.amount,
            due: invoice?.balance,
            discount: invoice?.discount,
          }}
          validationSchema={BillValidatoin}
          onSubmit={(values) => {
            invoiceSubmitHandler(values);
          }}
          enableReinitialize
        >
          {({ setFieldValue }) => (
            <Form onChange={(event) => handleFormValue(event, setFieldValue)}>
              <div className="monthlyBill">
                <span className="text-secondary">
                  {invoice?.customer?.name}
                </span>
                &nbsp;
                <span className="text-secondary">{t("totalAmount")} ৳</span>
                <span className="text-primary">{totalAmount} </span>
              </div>

              <div className="displayGrid">
                <div className="displayGrid2">
                  <div>
                    <label className="form-control-label changeLabelFontColor">
                      {t("billType")}
                      <span className="text-danger mx-1">*</span>
                    </label>
                    <select className="form-select mt-0 mw-100" disabled>
                      <option value="bill"> {t("bill")} </option>
                    </select>
                  </div>

                  <div>
                    <label
                      htmlFor="billingType_type"
                      className="form-control-label changeLabelFontColor"
                    >
                      {t("billingType")}
                      <span className="text-danger mx-1">*</span>
                    </label>

                    <select
                      as="select"
                      name="billingType"
                      className="form-select mt-0 mw-100"
                      disabled
                    >
                      <option value="monthly"> {t("monthly")} </option>
                    </select>
                  </div>

                  <FtextField type="number" name="amount" label={t("bill")} />

                  <FtextField type="number" name="due" label={t("due")} />

                  <div>
                    <label
                      htmlFor="receiver_type"
                      className="form-control-label changeLabelFontColor"
                    >
                      {t("medium")} <span className="text-danger mx-1">*</span>
                    </label>

                    <select
                      as="select"
                      id="receiver_type"
                      className="form-select mt-0 mw-100"
                      aria-label="Default select example"
                      onChange={(e) => setMedium(e.target.value)}
                      disabled
                    >
                      <option value="cash" selected>
                        {t("handCash")}
                      </option>
                      <option value="bKash"> {t("bKash")} </option>
                      <option value="rocket"> {t("rocket")} </option>
                      <option value="nagad"> {t("nagad")} </option>
                      <option value="others"> {t("others")} </option>
                    </select>
                  </div>
                </div>

                <div className="displayGrid2">
                  {(role === "ispOwner" || permissions.billDiscount) && (
                    <div>
                      <FtextField
                        type="number"
                        name="discount"
                        label={t("discount")}
                      />
                    </div>
                  )}

                  <div className="d-flex align-self-end">
                    <input
                      type="checkbox"
                      className="form-check-input me-1"
                      id="addnote"
                      checked={noteCheck}
                      onChange={(e) => setNoteCheck(e.target.checked)}
                    />
                    <label
                      className="form-check-label changeLabelFontColor"
                      htmlFor="addnote"
                    >
                      {t("noteAndDate")}
                    </label>
                  </div>
                </div>

                {noteCheck && (
                  <div class="form-floating">
                    <textarea
                      cols={200}
                      className="form-control shadow-none"
                      placeholder={t("writeNote")}
                      id="noteField"
                      onChange={(e) => setNote(e.target.value)}
                      value={note}
                    ></textarea>
                    <label htmlFor="noteField"> {t("addNote")} </label>
                  </div>
                )}
              </div>

              {/* Invoice Printer Page Component with button and they are hidden*/}
              <>
                {((role === "ispOwner" &&
                  bpSettings?.instantRechargeBillPrint) ||
                  ((role === "manager" || role === "collector") &&
                    permissions?.instantRechargeBillPrint &&
                    bpSettings?.instantRechargeBillPrint)) && (
                  <div className="d-none">
                    <CustomerInvoicePrint
                      ref={rechargePrint}
                      invoiceData={{
                        ...invoice,
                        status: "both",
                      }}
                      ispOwnerData={ispOwnerData}
                    />
                  </div>
                )}

                <div className="d-none">
                  <ReactToPrint
                    trigger={() => (
                      <div
                        title={t("printInvoiceBill")}
                        style={{ cursor: "pointer" }}
                      >
                        <button type="button" id="printButton">
                          Print
                        </button>
                      </div>
                    )}
                    content={() => rechargePrint.current}
                  />
                </div>
              </>

              <div className="d-flex justify-content-end mt-4">
                <button type="submit" className="btn btn-outline-success">
                  {isLoading ? (
                    <Loader />
                  ) : (
                    <span className="submitButton">
                      {t("pay")}
                      <CashStack />
                    </span>
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </ComponentCustomModal>
  );
}
